import ExtensionFWS1 from "../../assets/images/100-Extension-FWS1.png"
import accrediation from "../../assets/images/accrediation.png"
import compliance from "../../assets/images/compliance.png"
import contact from "../../assets/images/contact.png"
import distributors from "../../assets/images/distributors.png"
import drawingRevitbg from "../../assets/images/drawingRevitbg.png"
import faq from "../../assets/images/faq.png"
import homePageBannerImage from "../../assets/images/homePageBannerImage.png"
import installation_bg from "../../assets/images/installation_bg.jpg"
import LIlogo from "../../assets/images/LIlogo.svg"
import location from "../../assets/images/location.png"
import logo_footer_transparent_white from "../../assets/images/logo_footer_transparent_white.png"
import madeInAus from "../../assets/images/madeInAus.png"
import cert from "../../assets/images/W_LPCB_Issue2_C1457_SFS-Certificate.jpg"
import whiteFireOnly from "../../assets/images/white_fire_only.png"
import whiteFireRight from "../../assets/images/white_fire_only_right.png"

import ddd760x570 from "../../assets/images/ddd-760x570.png"
import qualityAccrediation from "../../assets/images/quality-accrediation.png"
import Report1 from "../../assets/images/report1-800x600.png"
import Report2 from "../../assets/images/report2-800x600.png"
import Snap_fire_systems_logomaroon from "../../assets/images/Snap_fire_systems_logomaroon.png"
import Snap_fire_systems_logowhite from "../../assets/images/Snap_fire_systems_logowhite.png"
import SNAPLogoWhite from "../../assets/images/SNAPLogo-white.png"
import testReportsBg from "../../assets/images/testReportsBg.jpg"
import uniqueSolutions from "../../assets/images/uniqueSolutions.png"

import AccessoriesFamily from "../../assets/images/productImages/P_Snap_BasePlates_family.png"
import FloorwasteAndShowerFamily from "../../assets/images/products/floorwaste-shower-fire-collars-hero.png"
import GasFamily from "../../assets/images/products/gas-fire-collars-hero.png"
import MultiServiceFamily from "../../assets/images/products/multi-service-fire-collars-hero.png"
import RetrofitFamily from "../../assets/images/products/retrofit-fire-collars-hero.jpg"
import SealantBannerHero from "../../assets/images/products/sealant-banner-hero.png"
import SealantTileHero from "../../assets/images/products/sealant-tile-hero.png"
import StackFamily from "../../assets/images/products/stack-fire-collars-hero.png"
import UtilityFamily from "../../assets/images/products/utility-fire-collars-hero.png"

import contactUs from "../../assets/images/contactus.jpg"
import faqBanner from "../../assets/images/faqBanner.jpg"
import imagePlaceHolder from "../../assets/images/L_image placeholder_image.png"
import MS70CWhenReleased from "../../assets/images/MS70C_when_released.png"

// Distributors
import accuraLogo from "../../assets/images/distributors/acura-logo.png"
import drillCutLogo from "../../assets/images/distributors/drillcut-logo.jpg"
import drillFastLogo from "../../assets/images/distributors/drillfast-logo.png"
import fyreguard from "../../assets/images/distributors/fyreguard-logo.jpg"
import globalLogo from "../../assets/images/distributors/global-logo.png"
import powaGroup from "../../assets/images/distributors/powa-group-logo.jpg"
import specfastLogo from "../../assets/images/distributors/specfast-logo.png"
import youstalogo from "../../assets/images/distributors/yousta-logo.png"

// Icons
import burgerIcon from "../../assets/images/burgerIcon.svg"
import edit_icon from "../../assets/images/edit_icon.svg"
import edit_icon_grey from "../../assets/images/edit_icon_grey.svg"
import archiveIcon from "../../assets/images/icons/archiveIcon.svg"
import copyPrimaryColor from "../../assets/images/icons/copy_primarycolor.svg"
import copyIcon from "../../assets/images/icons/copyIcon.svg"
import deleteIconWhite from "../../assets/images/icons/deleteIconWhite.svg"
import editSecondaryPrimary from "../../assets/images/icons/edit_secondaryPrimary.svg"
import elipses from "../../assets/images/icons/ellipsis.png"
import excelIcon from "../../assets/images/icons/excelIcon.svg"
import exportPrimaryColor from "../../assets/images/icons/export_primaryColor.svg"
import exportIcon from "../../assets/images/icons/exportIcon.svg"
import eyeIcon from "../../assets/images/icons/eyeIcon.svg"
import IconDelete from "../../assets/images/icons/IconDelete.svg"
import pdfIcon from "../../assets/images/icons/L_Adobe_pdf_white_icon.svg2.svg"
import editIcon from "../../assets/images/icons/L_edit_icon.svg1.svg"
import restoreIcon from "../../assets/images/icons/L_restoreicons.svg1.svg"
import userIcon from "../../assets/images/icons/L_user_icon2.svg"
import newfileIcon from "../../assets/images/icons/newFileIcon.svg"
import pdfPrimaryColor from "../../assets/images/icons/pdf_primaryColor.svg"
import pdfIconWhite from "../../assets/images/icons/pdfIcon.svg"
import revitIcon from "../../assets/images/icons/PenIcon.svg"
import plusIcon from "../../assets/images/icons/PlusIcon.svg"
import chevronI from "../../assets/images/icons/Property1-IconChevron-l.svg"
import chevronS from "../../assets/images/icons/Property1-IconChevron-s.svg"
import chevronThin from "../../assets/images/icons/Property1-IconChevron-thin-s.svg"
import chevronxxs from "../../assets/images/icons/Property1-IconChevron-xxs.svg"
import iconClosem from "../../assets/images/icons/Property1-IconClose-m.svg"
import iconCloses from "../../assets/images/icons/Property1-IconClose-s.svg"
import iconClosethick from "../../assets/images/icons/Property1-IconClose-thick.svg"
import iconClose from "../../assets/images/icons/Property1-IconClose.svg"
import iconPlusThin from "../../assets/images/icons/Property1-IconPlus-thin.svg"
import iconPlus from "../../assets/images/icons/Property1-IconPlus.svg"
import sharePrimaryColor from "../../assets/images/icons/share_primaryColor.svg"
import snapFooterIcon from "../../assets/images/icons/snapFooterIcon.png"
import closeIcon from "../../assets/images/icons/xIcon.svg"
import placeholderImage from "../../assets/images/imagePlaceholder.png"
import penIcon from "../../assets/images/penIcon.png"
import searchIcon from "../../assets/images/searchIcon.svg"

export const EyeIconImg = eyeIcon
export const CopyIconImg = copyIcon
export const PdfIconImg = pdfIconWhite
export const ExcelIconImg = excelIcon
export const ExportIconImg = exportIcon
export const ArchiveIconImg = archiveIcon
export const DeleteIconWhite = deleteIconWhite
export const SnapFooterIcon = snapFooterIcon

export const whiteFireOnlyImg = whiteFireOnly
export const whiteFireRightImg = whiteFireRight
export const PlaceholderFMPImage = placeholderImage

export const accrediationImg = accrediation
export const certImg = cert
export const complianceImg = compliance
export const contactImg = contact
export const distributorsImg = distributors
export const drawingRevitbgImg = drawingRevitbg

// Icons
export const editIconImg = edit_icon
export const editIconGreyImg = edit_icon_grey
export const PDFIconImg = pdfIcon
export const penIconImg = penIcon
export const revitIconImg = revitIcon
export const searchIconImg = searchIcon
export const burgerIconImg = burgerIcon
export const newFileIconImg = newfileIcon

export const faqImg = faq
export const homePageBannerImageImg = homePageBannerImage
export const installationBgImg = installation_bg
export const LIlogoImg = LIlogo
export const locationImg = location
export const logoFooterTransparentWhiteImg = logo_footer_transparent_white
export const madeInAusImg = madeInAus
export const qualityAccrediationImg = qualityAccrediation
export const SnapFireSystemsLogoMaroonImg = Snap_fire_systems_logomaroon
export const SnapFireSystemsLogoWhiteImg = Snap_fire_systems_logowhite
export const SNAPLogoWhiteImg = SNAPLogoWhite
export const testReportsBgImg = testReportsBg
export const uniqueSolutionsImg = uniqueSolutions
export const Report2Img = Report2
export const Report1Img = Report1
export const dddImg = ddd760x570

export const MS70CWhenReleasedImg = MS70CWhenReleased
export const powagroupLogoImg = powaGroup
export const AccuraLogoImg = accuraLogo
export const DrillCutLogoImg = drillCutLogo
export const DrillFastLogoImg = drillFastLogo
export const Fyreguard = fyreguard
export const GlobalLogo = globalLogo
export const SpecfastLogo = specfastLogo
export const Youstalogo = youstalogo
export const ImagePlaceHolder = imagePlaceHolder
export const ExtensionFWS1Img = ExtensionFWS1

export const StackFamilyImg = StackFamily
export const GasFamilyImg = GasFamily
export const MultiServiceFamilyImg = MultiServiceFamily
export const RetrofitFamilyImg = RetrofitFamily
export const AccessoriesImg = AccessoriesFamily
export const FloorwasteAndShowerImg = FloorwasteAndShowerFamily
export const UtilityFamilyImg = UtilityFamily
export const SealantBannerHeroImg = SealantBannerHero
export const SealantTileHeroImg = SealantTileHero

export const ContactUsBanner = contactUs
export const FAQBanner = faqBanner

// icons
export const elipsesImg = elipses
export const IconDeleteImg = IconDelete
export const pdfIconImg = pdfIcon
export const editIconImg2 = editIcon
export const restoreIconImg = restoreIcon
export const plusIconImg = plusIcon
export const chevronIImg = chevronI
export const chevronSImg = chevronS
export const chevronThinImg = chevronThin
export const chevronxxsImg = chevronxxs
export const iconClosemImg = iconClosem
export const iconClosesImg = iconCloses
export const iconClosethickImg = iconClosethick
export const iconCloseImg = iconClose
export const iconPlusThinImg = iconPlusThin
export const iconPlusImg = iconPlus
export const userIconImg = userIcon
export const closeIconImg = closeIcon

export const editSecondaryPrimaryImg = editSecondaryPrimary
export const copyPrimaryColorImg = copyPrimaryColor
export const exportPrimaryColorImg = exportPrimaryColor
export const sharePrimaryColorImg = sharePrimaryColor
export const pdfPrimaryColorImg = pdfPrimaryColor
